import React from 'react';
import TableBadge from '@spark/ui-components/components/TanStackTable/components/TableBadge';
import TruncatedText from '@spark/ui-components/components/TanStackTable/components/TruncatedText';
import Tooltip from '@spark/ui-components/components/Tooltip';
/**
 * Colunas da tabela de pedidos usando TanStack Table
 */

export const getPedidosColumns = (handleEditar, handleExcluir) => [
  {
    id: 'Titulo',
    header: 'Titulo da Vaga',
    accessorKey: 'Titulo',
    size: 150,
    enableSorting: true,
    cell: ({
      getValue
    }) => <TruncatedText value={getValue()} maxLength={40} />
  }, {
    id: 'Descricao',
    header: 'Descrição da Vaga',
    accessorKey: 'Descricao',
    size: 140,
    enableSorting: true,
    cell: ({
      getValue
    }) => <TruncatedText value={getValue()} maxLength={40} />
  }, {
    id: 'Data_abertura',
    header: 'Data de Abertura',
    accessorKey: 'Data_abertura',
    size: 140,
    enableSorting: true,
    cell: ({ getValue }) => {
      const raw = getValue();
      if (!raw) return '';

      const date = new Date(raw);
      const formatted = date.toLocaleDateString('pt-BR');

      return <TruncatedText value={formatted} maxLength={40} />;
    }
  }, {
    id: 'NecessitaCNH',
    header: 'Necessidade de CNH',
    accessorKey: 'NecessitaCNH',
    size: 120,
    enableSorting: true,
    cell: ({ getValue }) => {
      const value = getValue();
      return value === 1 ? 'Sim' : 'Não';
    }
  }
];
